import React, { useEffect, useState } from 'react'
import './Carosel.css'
import Slider from 'react-slick'
import { Skeleton, Box } from '@mui/material'
import {
  IMAGE_BASE_PATH_DBRAIMT,
  IMAGE_BASE_PATH_COMMON,
} from '../../Config/Config'

const Image_Carosel = (props) => {
  const { image_data, imageStyle } = props
  const defaultStyles = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
  }

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (image_data && image_data.length > 0) {
      const imageLoadPromises = image_data.map((item) => {
        return new Promise((resolve) => {
          const img = new Image()
          img.src = IMAGE_BASE_PATH_DBRAIMT + item.file_path
          img.onload = resolve
          img.onerror = resolve
        })
      })

      Promise.all(imageLoadPromises).then(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [image_data])

  return (
    <div className="Image_carosel">
      {loading ? (
        <Skeleton
          variant="rectangular"
          animation="wave"
          sx={{
            ...defaultStyles,
            width: '100%',
            mb: 2,
          }}
        />
      ) : (
        <Slider
          ref={(slider) => slider}
          arrows={false}
          autoplay={true}
          dots={true}
        >
          {image_data && image_data.length > 0 ? (
            image_data.map((items, index) => {
              const imageUrl =
                items?.file_path !== ''
                  ? IMAGE_BASE_PATH_DBRAIMT + items.file_path
                  : IMAGE_BASE_PATH_COMMON + 'Placeholder_Image.jpg'

              return (
                <Box key={index}>
                  <img
                    src={imageUrl}
                    alt="carousel slide"
                    loading="lazy"
                    style={
                      imageStyle
                        ? { ...defaultStyles, ...imageStyle }
                        : defaultStyles
                    }
                    onError={(e) =>
                      (e.target.src =
                        IMAGE_BASE_PATH_COMMON + 'Placeholder_Image.jpg')
                    }
                  />
                </Box>
              )
            })
          ) : (
            <Box>
              <img
                src={
                  IMAGE_BASE_PATH_COMMON + 'Placeholder_Image.jpg'
                }
                alt="no data"
                style={defaultStyles}
              />
            </Box>
          )}
        </Slider>
      )}
    </div>
  )
}

export default Image_Carosel
